<script setup lang="ts">
    import { onMounted } from 'vue';
    import { usePublicLinkStore } from '../stores/public-link';
    import SharedDashboardReport from '../components/public-link/SharedDashboardReport.vue';
    import PasswordForm from '../components/public-link/PasswordForm.vue';

    const publicLink = usePublicLinkStore();

    onMounted(() => {
        if (!publicLink.passwordRequired) {
            publicLink.getDashboard();
        }
    });

    const handlePasswordSubmit = async (password: string) => {
        await publicLink.getDashboard(password);
    };
</script>
<template>
    <SharedDashboardReport v-if="publicLink.dashboard" :dashboard="publicLink.dashboard" />
    <PasswordForm
        v-else
        :error="publicLink.error"
        :loading="publicLink.loading"
        @submit="handlePasswordSubmit"
    />
</template>
